import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import {Grid } from '@material-ui/core';
import { Box, Card, CardContent, Button, FormControl, InputLabel, Select, MenuItem, Checkbox, TextField } from '@mui/material';
import MainCard from '../MainCard';
import axios from "../../../components/axios";


const NestlingPlusForm = ({title, columns, queryURL, downloadURL}) => {
    const styleButton = {
    backgroundColor: "#406599",
    color: "#fff",
    borderRadius: "5px",
    boxSizing: "border-box",
    fontFamily: '"Roboto", "sans-serif"',
    fontSize: "15px",
  };

  const styleSendButton = {
    marginTop: "10px",
    color:'#406599',
    fontFamily: '"Roboto", "sans-serif"',
  };

  const styleField = {
    width: '70%',
  };

  const styleBox = {
    fontSize: '20px', 
    color:"#406599", 
    pb:'20px',
    pl:'15px',
    pr:'30px'
  };

  const navigate = useNavigate();
  const [typeList, setTypeList] = useState([]);
  const [type, setType] = useState("");
  function handleType(e) {
        setType(e.target.value);
        setNode("");
        setDevice("");
        getNameOptions(e.target.value);
  }

  const [nameList, setNameList] = useState([]);
  const [name, setName] = useState("");
  function handleName(e) {
        setName(e.target.value);
        getNodeOptions(e.target.value);
  }

  const [nodeList, setNodeList] = useState([]);
  const [node, setNode] = useState("");
  function handleNode(e) {
        setNode(e.target.value);
        getDeviceOptions(e.target.value);
  }

  const [deviceList, setDeviceList] = useState([]);
  const [device, setDevice] = useState("");
  function handleDevice(e) {
        setDevice(e.target.value);
  }
  const [checkTestrail, setCheckTestrail] = useState(false);
  const handleCheckTestrailChange = (event) => {
    setCheckTestrail(event.target.checked);
  };

  const [checkUploadAttachment, setCheckUploadAttachment] = useState(false);
  const handleCheckUploadAttachmentChange = (event) => {
    setCheckUploadAttachment(event.target.checked);
  };

  const [checkQbarn, setCheckQbarn] = useState(false);
  const handleCheckQbarnChange = (event) => {
    setCheckQbarn(event.target.checked);
  };

  const retry_failed_options = [
    { value: 0},
    { value: 1},
    { value: 2},
  ];
  const [retry, setRetry] = useState(0);
  function handleRetry(e) {
        setRetry(e.target.value);
  }

  const [xml, setXml] = useState("");
  function handleXml(e) {
        setXml(e.target.value);
  }
  const [branch, setBranch] = useState("");
  function handleBranch(e) {
        setBranch(e.target.value);
  }
  const [systemAppPatch, setSystemAppPatch] = useState("");
  function handleSystemAppPatch(e) {
        setSystemAppPatch(e.target.value);
  }
  const [slack, setSlack] = useState("");
  function handleSlack(e) {
        setSlack(e.target.value);
  }
  const getTypeOptions = async () => {
    const response = await axios.post("/peloton/v1/automation/freestyle-type-options", null, { withCredentials: true});
    setTypeList(response.data.options);
  }

  useEffect(() => {
    getTypeOptions();
  }, []);

  const getNameOptions = async (type_id) => {
    var input_data = JSON.stringify({ id: type_id })
    const response = await axios.post("/peloton/v1/automation/freestyle-name-options", input_data, { withCredentials: true});
    setNameList(response.data.options);
  }

  const getNodeOptions = async (test_name) => {
    var input_data = JSON.stringify({ test_name: test_name })
    const response = await axios.post("/peloton/v1/automation/freestyle-node-options", input_data, { withCredentials: true});
    setNodeList(response.data.options);
  }

  const getDeviceOptions = async (node_name) => {
    var input_data = JSON.stringify({ node_name: node_name })
    const response = await axios.post("/peloton/v1/automation/freestyle-device-options", input_data, { withCredentials: true});
    setDeviceList(response.data.options);
  }

  const handleSendButton = () => {
    var input_data = JSON.stringify({ test_type: type, test_name: name, test_node: node, test_device: device, 
      testrail: checkTestrail, upload_attachment: checkUploadAttachment, qbarn: checkQbarn, retry_failed: retry, 
      payload_env: payload, test_round: round, run_xml: xml, branch: branch, system_app_patch: systemAppPatch,
      slack: slack});

    axios.post("/peloton/v1/automation/freestyle-item",input_data,{withCredentials: true})
    .then(response => {
      if (response.data.message === "success") {
        setType('');
        setName('');
        setNode('');
        setDevice('');
        setCheckTestrail(false);
        setCheckUploadAttachment(false);
        setCheckQbarn(false);
        setRetry(0);
        setPayload('prod');
        setRound('default');
        setXml("");
        setBranch("");
        setSystemAppPatch("");
        setSlack("");
      }
      alert(response.data.message);
    }).catch(function(err){
      if (!err.response){
            alert(err);
      }else{
        if (err.response.status === 401){
          alert(err.response.data.message);
          navigate("/");
        }else{
          console.log('error.response.status: ', err.response.status)
          console.log('error.response.status: ', err.response.data.message)
          alert(err.response.data.message)
        }
      }
    })
  };

  const payload_env_options = [
    { value: 'prod'},
    { value: 'test'},
  ];
  const [payload, setPayload] = useState('prod');
  function handlePayload(e) {
    setPayload(e.target.value);
  };

  const test_round_options = [
    { value: 'default'},
    { value: '1'},
    { value: '3'},
    { value: '5'},
    { value: '10'},
    { value: '20'},
    { value: '50'},
  ];
  const [round, setRound] = useState('default');
  function handleRound(e) {
    setRound(e.target.value);
  };

  return (
    <MainCard title={title}>
      <Card variant="outlined" sx={{ bgcolor: "white" }}>
      <CardContent>
       <Box sx={{ fontSize: '20px', color:"#406599", pb:'15px'}}>
          {title}
      </Box>
      <Box sx={styleBox}>
        <FormControl style={styleField} >
          <InputLabel id="demo-simple-select-standard-label">Select Test Type</InputLabel>
            <Select
              id="project"
              fullWidth
              value={type}
              onChange={handleType}
              variant="filled"
            >
              {typeList.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
        </FormControl>
      </Box>
      <Box sx={styleBox}>
        <FormControl style={styleField} >
          <InputLabel id="demo-simple-select-standard-label">Select Test Name</InputLabel>
            <Select
              id="project"
              fullWidth
              value={name}
              onChange={handleName}
              variant="filled"
            >
              {nameList.map((option) => (
                <MenuItem key={option.name} value={option.name}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
        </FormControl>
      </Box>
      <Box sx={styleBox}>
        <FormControl style={styleField} >
          <InputLabel id="demo-simple-select-standard-label">Select Test Node</InputLabel>
            <Select
              id="project"
              fullWidth
              value={node}
              onChange={handleNode}
              variant="filled"
            >
              {nodeList.map((option) => (
                <MenuItem key={option.name} value={option.name}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
        </FormControl>
      </Box>
      <Box sx={styleBox}>
        <FormControl style={styleField} >
          <InputLabel id="demo-simple-select-standard-label">Select Test Device</InputLabel>
            <Select
              id="project"
              fullWidth
              value={device}
              onChange={handleDevice}
              variant="filled"
            >
              {deviceList.map((option) => (
                <MenuItem key={option.name} value={option.name}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
        </FormControl>
      </Box>
      <Box sx={styleBox}>
        <Checkbox
              checked={checkTestrail}
              onChange={handleCheckTestrailChange}
              inputProps={{ 'aria-label': 'primary checkbox' }}
              sx={{
                color: "#406599",
                '&.Mui-checked': {
                  color: "#406599",
                },
              }}
            />Testrail
      </Box>
      <Box sx={styleBox}>
        <Checkbox
              checked={checkUploadAttachment}
              onChange={handleCheckUploadAttachmentChange}
              inputProps={{ 'aria-label': 'primary checkbox' }}
              sx={{
                color: "#406599",
                '&.Mui-checked': {
                  color: "#406599",
                },
              }}
            />Upload Attachment
      </Box>
      <Box sx={styleBox}>
        <Checkbox
              checked={checkQbarn}
              onChange={handleCheckQbarnChange}
              inputProps={{ 'aria-label': 'primary checkbox' }}
              sx={{
                color: "#406599",
                '&.Mui-checked': {
                  color: "#406599",
                },
              }}
            />QBarn
      </Box>
      <Box sx={styleBox}>
        <FormControl style={styleField} >
          <InputLabel id="demo-simple-select-standard-label">Select Retry Failed</InputLabel>
            <Select
              id="project"
              fullWidth
              value={retry}
              onChange={handleRetry}
              variant="filled"
            >
              {retry_failed_options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.value}
                </MenuItem>
              ))}
            </Select>
        </FormControl>
      </Box>
      <Box sx={styleBox}>
        <FormControl style={styleField} >
          <InputLabel id="demo-simple-select-standard-label">Select Payload Env</InputLabel>
            <Select
              id="project"
              fullWidth
              value={payload}
              onChange={handlePayload}
              variant="filled"
            >
              {payload_env_options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.value}
                </MenuItem>
              ))}
            </Select>
        </FormControl>
      </Box>
      <Box sx={styleBox}>
        <FormControl style={styleField} >
          <InputLabel id="demo-simple-select-standard-label">Select Test Round</InputLabel>
            <Select
              id="project"
              fullWidth
              value={round}
              onChange={handleRound}
              variant="filled"
            >
              {test_round_options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.value}
                </MenuItem>
              ))}
            </Select>
        </FormControl>
      </Box>
      <Box sx={styleBox}>
        <FormControl style={styleField} >
        <TextField
          label="RunXML"
          multiline
          maxRows={Infinity}
          value={xml}
          onChange={handleXml}
        />
        </FormControl>
      </Box>
      <Box sx={styleBox}>
        <FormControl style={styleField} >
        <TextField
          label="Branch"
          multiline
          maxRows={Infinity}
          value={branch}
          onChange={handleBranch}
        />
        </FormControl>
      </Box>
      <Box sx={styleBox}>
        <FormControl style={styleField} >
        <TextField
          label="System App Patch"
          multiline
          maxRows={Infinity}
          value={systemAppPatch}
          onChange={handleSystemAppPatch}
          helperText={
            <>
              Fill in the apk download link on jenkins<br />
              The default is to use the latest RC branch.<br />
              ex:<br />
              https://cfx-ci.pelotime.com/job/affernet-service-rc-builder/2/artifact/apks/affernet-service-androidN-release.apk<br />
              https://cfx-ci.pelotime.com/job/platform-apps-pr-builder/lastSuccessfulBuild/artifact/apks/raccoon-androidN-release-aligned.apk
            </>
          }
        />
        </FormControl>
      </Box>
      <Box sx={styleBox}>
        <FormControl style={styleField} >
        <TextField
          label="Slack"
          multiline
          maxRows={Infinity}
          value={slack}
          onChange={handleSlack}
          helperText={
            <>
              Enter the place where you want to send the slack report<br />
              ex:<br />
              #automation_playground<br />
              @brian.chang
            </>
          }
        />
        </FormControl>
      </Box>
      </CardContent>
      </Card>
      <Grid container justifyContent="flex-end" style={styleSendButton}>
        <Button style={styleButton} onClick={handleSendButton}>Send</Button>
      </Grid>
    </MainCard>
  );
};

export default NestlingPlusForm;
